import { render, staticRenderFns } from "./gridLinkGroup.vue?vue&type=template&id=20b25a32&"
import script from "./gridLinkGroup.vue?vue&type=script&lang=js&"
export * from "./gridLinkGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports